import { useDispatch } from 'react-redux';
import { useCallback, useContext } from 'react';
import { UserContext } from 'shared/Providers/User';
import { apiDeactivateUser } from 'shared/modules/user/actions';
import { Button, Typography } from '@mui/material';
import SettingsItem from 'shared/_ui/settings-item';

export default function SettingsDeleteAccount() {
	const dispatch = useDispatch();
	const { user } = useContext(UserContext);

	const handleDeleteAccount = useCallback(async () => {
		const answer = window.confirm(
			'Be careful:\n' +
				'The current user will be deactivated and you WILL NOT BE ABLE to log in.\n' +
				'Continue?'
		);

		if (answer) {
			await dispatch(apiDeactivateUser(user?.id));
		}
	}, [user?.id, dispatch]);

	return (
		<SettingsItem
			control={
				<Button color="error" onClick={handleDeleteAccount}>
					Delete
				</Button>
			}
		>
			<div>
				<Typography variant="h4" fontSize="1rem">
					Delete Account
				</Typography>
				<Typography color="secondary">Permanently delete your account and all data</Typography>
			</div>
		</SettingsItem>
	);
}
